import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['template', 'subject', 'body']

  fill() {
    const opt = this.templateTarget.selectedOptions[0]
    if (!opt || !opt.value) return
    if (opt.dataset.subject) this.subjectTarget.value = opt.dataset.subject
    if (opt.dataset.body) this.bodyTarget.value = opt.dataset.body
  }
}
